import { useContext } from 'react';
import BPHeader from './BPHeader';
import BPFooter from './BPFooter';
import BPSection from './BPSection';

// Context
import { BusinessPartnerContext } from './BusinessPartnerCard';
import { SECTIONS } from './utils';

const BPCabie = () => {
  const { localBPData, isEditing, handleOnChange, dropdownValues, errors, handleShowModal } =
    useContext(BusinessPartnerContext);

  return (
    <>
      <section className="bp-cabie">
        <BPHeader />
        <BPSection
          sections={SECTIONS['bp-cabie']}
          isEditing={isEditing}
          localBPData={localBPData}
          dropdownValues={dropdownValues}
          errors={errors}
          handleOnChange={handleOnChange}
          handleShowModal={handleShowModal}
        />
      </section>
      <BPFooter />
    </>
  );
};

export default BPCabie;
